import { css } from 'linaria';

export const stickyPanelWithNavigation = css`
  z-index: 2;
`;

export const stickyPanelWithNavigationAtTop = css`
  width: 1180px;
`;

export const stickyPanelWithNavigationFullWidth = css`
  position: sticky;
  top: 0;
  max-width: 100vw;
  width: 100vw;
  z-index: 1;

  &::before {
    content: '';
    position: absolute;
    bottom: 0;
    right: 0;
    width: 200vw;
    height: 1px;
    background-color: var(--control-minor);
    z-index: 1;
    animation: animation 300ms ease-in;
  }

  &::after {
    content: '';
    position: absolute;
    bottom: 0;
    right: 0;
    width: 200vw;
    height: 100%;
    background-color: var(--background-primary);
    animation: animation 300ms ease-in;
  }

  @keyframes animation {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
`;

export const stickyPanelSentinel = css`
  height: 1px;
`;

export const addToBasket = css`
  [data-qa='to-basket-button'] {
    min-width: 40px;
    margin-left: var(--space-100);
  }
`;

export const counter = css`
  width: 162px;
  height: 40px;

  input {
    font-size: 15px !important;
  }

  button {
    padding: 0 var(--space-125);
  }
`;

export const borderStyle = css`
  & > * {
    background: linear-gradient(#e1e2e5, #e1e2e5) 0 100%/100% 1px no-repeat;
  }
`;
